import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import SearchBar from '../../../Component/SearchBar.js';
import { SuccessfulPopup } from '../../../Component/Modals/SuccessfulPopup.js';
import Table from '../../../Component/Table.js';
import edit from '../../../assets/icons/editnew.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { AddOrganisationModal } from '../../../Component/Modals/AddOrganisationModal.js';
import { getData, getDataById, getSingleDataById, patchData, Postdata, Postdataform, PostdataWithJson, updateData, UpdateDataForm, UpdateDataFormWithJson } from '../../../API/GlobalApi.js';
import { Addfee } from '../../../Component/Modals/AddFee.js';
import debounce from 'lodash.debounce';

import SpinnerLoader from '../../../Utils/Spinner.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import ExpandedContent from './ExpandedDetailsCourse.js';
import { CourseWiseFeePlanView } from '../../../Component/Modals/CourseWiseFeePlanShow.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import Select from 'react-select'

export const ImposeClassesFee = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [selectedFeePlan, setSelectedFeePlan] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [feePlanData, setFeePlanData] = useState([])
    const [modalMode, setModalMode] = useState('create');
    const [filterFeePlan, setFilterPlan] = useState([])
    const [filterQueryString, setFilterQueryString] = useState('');
    const navigate = useNavigate();
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [filterLoading, setFilterLoading] = useState(false);
    const [addCourse_Specialization_FeeModal, setCourse_specialization_feeModal] = useState(false)
    const [cachedSelectedFee, setCachedSelectedFeePlan] = useState(null);
    const [openCourseWiseFeePlanModal, setOpenCourseWiseFeePlanModal] = useState(false)
    const [courseWiseFeePlan, setCourseWiseFeePlan] = useState([])
    const [isLoadingCoursePlan, setIsLoadingCoursePlan] = useState(false);

    const handleOpenCourseWiseFeePlan = async (id) => {
        setIsLoadingCoursePlan(true);
        const res = await getData(`finance/course-fee-plans/?specialization_id=${id}`);

        setCourseWiseFeePlan(res?.results?.results || []);
        setOpenCourseWiseFeePlanModal(true);
        setIsLoadingCoursePlan(false);
    };


    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    const getSessions = async () => {
        const response = await getData("academics/academic-years/")
        const options = response?.map((session) => ({
            value: session.id,
            label: session.name,
            is_current: session.is_current,
        }));

        setSessions(options);

        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);

        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    useEffect(() => {
        getSessions();
    }, []);



    const closeAddCourseSpecializationFeeModal = () => {
        setCourse_specialization_feeModal(false)
        if (modalMode === 'create') {
            setSelectedFeePlan(cachedSelectedFee);
        }

    }
    const [modalLoading, setModalLoading] = useState(false)
    const getFeePlan = async (page = 0) => {
        const pageNumber = page + 1;

        // 🔹 Include selected academic year filter
        // const academicYearQuery = selectedSession
        //     ? `academic_year_id=${selectedSession.value}`
        //     : "";

        // 🔹 Merge with existing filters
        // const queryParts = [filterQueryString, academicYearQuery].filter(Boolean);
        const queryParts = [filterQueryString].filter(Boolean);
        const finalQueryString = queryParts.length > 0 ? queryParts.join("&") : "";

        // 🔹 Build final URL
        const url = finalQueryString
            ? `finance/specializations/?${finalQueryString}&page=${pageNumber}`
            : `finance/specializations/?page=${pageNumber}`;

        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);

        try {
            const response = await getData(url);
            const count = response?.count || 0;

            setFeePlanData(response);
            setFilterPlan(response);
            setTotalCount(count);
        } catch (error) {
            Notifier.error(error);
            setFeePlanData([]);
            setTotalCount(0);
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
        }
    };



    // useEffect(() => {
    //     getFeePlan(currentPage);
    // }, [currentPage, filterQueryString, refreshKey]);


    // useEffect(() => {
    //     if (selectedSession) {
    //         setFilterLoading(true);   // ✅ Show center loader
    //         setCurrentPage(0);        // (Optional) Reset page to 1 when session changes
    //         getFeePlan(0);

    //     }
    // }, [currentPage,selectedSession, filterQueryString]);



    useEffect(() => {

        setFilterLoading(true);
        // setCurrentPage(0);
        getFeePlan(currentPage);


    }, [currentPage, filterQueryString]);




    const handleStatus = () => {

    }
    const [selectedCourseId, setSelectedCourseId] = useState()

    const handleRowClick = async (id, row) => {
        setSelectedCourseId(id)
        // const res = await getData(`finance/specializations/${id}/academic-groups/`);
        // setSelectedFeePlan(res)
    };



    const sourceData = useMemo(() => {
        return filterQueryString ? filterFeePlan : feePlanData;
    }, [feePlanData, filterFeePlan, filterQueryString]);

    const formattedData = useMemo(() => {
        return sourceData?.map((fee) => ({
            id: fee.id,
            specialization_id: fee.specialization_id,
            specialization: fee.full_name,
            academic_year: fee.academic_year,
            course_code: fee.course_code,
            course__duration: fee.course__duration,
            intech_capacity: fee.intech_capacity,
            academic_groups: fee.academic_groups,
            handleRowClick,
        }));
    }, [sourceData]);



    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Course",
                accessor: "specialization",
                disableSortBy: true,
                Cell: ({ row }) => {
                    const isExpanded = row.isExpanded;
                    console.log("isExpanded===>", isExpanded)
                    return (
                        <div
                            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                            onClick={() => handleRowClick(row.original.id, row)}
                        >
                            {isExpanded ? (
                                <svg width={14} height={14} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "6px" }}>
                                    <path d="M5 7l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            ) : (
                                <svg width={14} height={14} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "6px" }}>
                                    <path d="M7 5l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                            <p
                                style={{ textAlign: "left", color: "#222F3E", fontWeight: 500, margin: 0, cursor: "pointer", textDecoration: 'underline' }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleOpenCourseWiseFeePlan(row.original.id, row.original)
                                }}
                            >
                                {row.original.specialization}
                            </p>
                        </div>
                    );
                },
            },
            {
                Header: () => <p style={{ textAlign: "left" }}>Course Code</p>,
                accessor: "course_code",
                disableSortBy: true,
                Cell: ({ row }) => <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">{row.original.course_code}</p>,
            },
            // {
            //     Header: () => <p style={{ textAlign: "left" }}>Admission Academic Year</p>,
            //     accessor: "academic_year",
            //     disableSortBy: true,
            //     Cell: ({ row }) => <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>{row.original.academic_year}</p>,
            // },


            {
                id: "total_semesters", // unique id
                Header: "Total Semesters",
                disableSortBy: true,
                accessor: "academic_groups",
                Cell: ({ value }) => value?.length || 0,
            },
            {
                id: "total_sections", // unique id
                Header: "Total Sections",
                disableSortBy: true,
                accessor: "academic_groups",
                Cell: ({ value }) => value?.reduce((secSum, group) => secSum + (group.lags?.length || 0), 0) || 0,
            },
            {
                id: "total_students", // unique id
                Header: "Total Students",
                accessor: "academic_groups",
                disableSortBy: true,
                Cell: ({ value }) =>
                    value?.reduce(
                        (stuSum, group) =>
                            stuSum +
                            (group.lags?.reduce((s, section) => s + (section.students?.length || 0), 0) || 0),
                        0
                    ) || 0,
            },
            {
                id: "total_imposed", // unique id
                Header: () => <p style={{ textAlign: "right" }}>Total Imposed Amount</p>,
                accessor: "academic_groups",
                disableSortBy: true,
                Cell: ({ value }) => {
                    const total = (
                        value?.reduce((amountSum, group) => {
                            return (
                                amountSum +
                                (group.lags?.reduce((secSum, section) => {
                                    return (
                                        secSum +
                                        (section.students?.reduce((stuSum, st) => {
                                            return (
                                                stuSum +
                                                (st.fee_schedules?.reduce(
                                                    (feeSum, fee) => feeSum + parseFloat(fee.amount || 0),
                                                    0
                                                ) || 0)
                                            );
                                        }, 0) || 0)
                                    );
                                }, 0) || 0)
                            );
                        }, 0) || 0
                    ).toFixed(2);

                    return <div className="no-text-cursor" style={{ textAlign: "right" }}>₹ {total}</div>;
                },
            }

        ],
        []
    );

    const handleSetSearchResults = (data) => {
        setFilterPlan(Array.isArray(data) ? data : []);
    };

    const handlePageChange = ({ selected }) => {

        setCurrentPage(selected);
        handlePaginate({
            selectedPage: selected,
            url: 'finance/specializations/',
            filterQueryString,
            setResults: handleSetSearchResults,
            setTotalCount,
            setFilterQueryString,
        });
    }

    return (
        <>{isLoading ? <TableSkeleton rows={10} columns={7} showHeader={true} /> : (
            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
            }}>
                <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    <div className='row mb-3'>
                        <div className="col-md-12 d-flex justify-content-end gap-5">


                            <button className='add-btn' onClick={() => navigate("/finance/add-student-fee-plan")}><span className='me-2'>
                                <svg width="12" height="12" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z" fill="white" />
                                </svg>
                            </span>Impose fee</button>


                        </div>
                    </div>

                </div>
                <div style={{ flexShrink: 0, padding: "8px 12px" }}>

                    <div className="row align-items-center">
                        {/* 🔹 Left Title (5 cols) */}
                        <div className="col-md-5">
                            <h2 className="main-heading mb-0">Impose Fee & Due</h2>
                        </div>

                        {/* 🔹 Right Section (7 cols): Search (5) + Session (2) */}
                        <div className="col-md-7">
                            <div className="row align-items-end justify-content-end">

                                {/* Search Bar First */}
                                <div className="col-md-8 d-flex justify-content-end">
                                    <SearchingBar
                                        placeholder="Search by Course name, Course code, Fee head"
                                        url="/finance/specializations/"
                                        filterQueryString={filterQueryString}
                                        setResults={handleSetSearchResults}
                                        ref={searchInputRef}
                                        setTotalCount={setTotalCount}
                                        setFilterQueryString={setFilterQueryString}
                                        setSearchLoading={setSearchLoading}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>

                                {/* Admission Academic Year After Search */}
                                {/* <div className="col-md-4">
                                        <label className="form-label mb-1">Admission Academic Year</label>
                                        <Select
                                            options={sessions}
                                            value={selectedSession}
                                            onChange={(opt) => setSelectedSession(opt)}
                                            styles={{
                                                ...reactSelectStyles,
                                                control: (base, state) => ({
                                                    ...reactSelectStyles.control?.(base, state),
                                                    minHeight: "34px",
                                                }),
                                            }}
                                            placeholder="Select Session"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                    </div> */}

                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    padding: "0 12px",
                    position: "relative",
                }}>
                    
                            {filterLoading ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '60vh',
                                        minHeight: '60vh',
                                        // paddingLeft: '20%',
                                        borderRadius: '8px',
                                        // backgroundColor: 'red',
                                    }}
                                >
                                    <SpinnerLoader />
                                </div>
                            )
                                : formattedData && formattedData?.length > 0 ? (
                                    <AdvanceTable
                                        columns={columns}
                                        pageCounts={pageCounts}
                                        handlePageChange={handlePageChange}
                                        selectedData={selectedFeePlan}
                                        data={formattedData}
                                        handleRowClick={handleRowClick}
                                        currentPage={currentPage}
                                        ExpandComponent={({ row }) => (
                                            <ExpandedContent specialization={row} /> // semesters → sections → students
                                        )}
                                        expandable={true}
                                    // checkbox={false}
                                    />
                                ) : (!isLoading && !isSearchLoading && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '60vh',
                                            paddingLeft: '50%',
                                            color: '#888',
                                            borderRadius: '8px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        No Fee Plan available.
                                    </div>
                                )
                                )}


                        </div>
                   
            </div >
        )}
            <div>

                <CourseWiseFeePlanView isOpen={openCourseWiseFeePlanModal} onClose={() => setOpenCourseWiseFeePlanModal(false)} courseWiseFeePlan={courseWiseFeePlan} isLoadingCoursePlan={isLoadingCoursePlan} />
            </div>



        </>
    );
};